function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const ContentSmall = /*#__PURE__*/React.forwardRef((props, ref) => {
  const baseStyle = {
    '@media (maxWidth: 400px)': {
      width: '98%'
    },
    '@media (maxWidth: 600px)': {
      width: '95%'
    },
    '@media (maxWidth: 1500px)': {
      width: '75%'
    },
    '@media (maxWidth: 2000px)': {
      width: '60%'
    },
    margin: '20px auto',
    width: '45%',
    ...props.style
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props, {
    style: baseStyle
  }), props.children);
});
export default ContentSmall;